import { DOCUMENT } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { EventEmitter, Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { map } from "rxjs/operators";
import { environment } from "src/environments/environment.prod";

import { logoutGameBall } from "../gameball";
import { AccountSettingService } from "./account-setting.service";
import { EmbryoService } from "./Embryo.service";
import { ReactivityService } from "./reactivity.service";
import { StaticPagesService } from "./static-pages.service";

@Injectable({
    providedIn: "root",
})
export class LoginUsersService {
    public userEmit = new EventEmitter();
    public userAreaChanged = new EventEmitter();
    loginRoute: any;
    environmentVariables: any;

    constructor(
        private http: HttpClient,
        private reactivityService: ReactivityService,
        private embroService: EmbryoService,
        private account: AccountSettingService,
        private confgServ: StaticPagesService
    ) {}
    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
    }

    setUserLanguage(data: any) {
        return this.http.post(
            `${environment.api}/api/customer/profile/language_settings`,
            data
        );
    }

    loginUsers(data: any) {
        return this.http
            .post<any>(`${environment.api}/api/customer/auth`, data, {
                headers: {
                    Authorization: " ",
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers":
                        "X-API-KEY, Origin, X-Requested-With ,, Accept, Access-Control-Request-Method, Authorization",
                    "Access-Control-Allow-Methods":
                        "GET, POST, OPTIONS, PUT, DELETE",
                },
            })
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    loginPhoneToVerify(data: any) {
        return this.http
            .post<any>(`${environment.api}/api/customer/auth-otp`, data, {
                headers: {
                    Authorization: " ",
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers":
                        "X-API-KEY, Origin, X-Requested-With ,, Accept, Access-Control-Request-Method, Authorization",
                    "Access-Control-Allow-Methods":
                        "GET, POST, OPTIONS, PUT, DELETE",
                },
            })
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    phoneVerifyOtp(data: any = ''): any {
        return this.http.post<any>(
          `${environment.api}/api/customer/auth-verify-otp`,
          data
        );
      }

    getProfile() {
        return this.http
            .get<any>(`${environment.api}/api/customer/profile`, {
                headers: {
                    Authorization: " ",
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers":
                        "X-API-KEY, Origin, X-Requested-With ,, Accept, Access-Control-Request-Method, Authorization",
                    "Access-Control-Allow-Methods":
                        "GET, POST, OPTIONS, PUT, DELETE",
                },
            })
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    checkSocial(data: any) {
        return this.http
            .post<any>(`${environment.api}/api/customer/auth/social`, data, {
                headers: {
                    Authorization: " ",
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers":
                        "X-API-KEY, Origin, X-Requested-With ,, Accept, Access-Control-Request-Method, Authorization",
                    "Access-Control-Allow-Methods":
                        "GET, POST, OPTIONS, PUT, DELETE",
                },
            })
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    deleteAccount() {
        return this.http
            .post<any>(`${environment.api}/api/customer/delete/my_account`, {})
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    getToken() {
        var old_token = localStorage.getItem("auth_token_crocs");
        var guest_token =
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL21vYmlsYXR5YXBpLmVsLWRva2FuLmNvbS9hcGkvY3VzdG9tZXIvYXV0aC9ndWVzdCIsImlhdCI6MTYxMjgxNDExNiwiZXhwIjozNzYxMjgxNDExNiwibmJmIjoxNjEyODE0MTE2LCJqdGkiOiJucGRzYVpJdnV5Mm1PM2NQIiwic3ViIjo5OTk5OTksInBydiI6IjRhYzA1YzBmOGFjMDhmMzY0Y2I0ZDAzZmI4ZTFmNjMxZmVjMzIyZTgifQ.BkXuKfrX6TjyA0UJrd0h3Z_CCL0GXRA_M3-cBAyfWgA";

        if (old_token && guest_token != old_token) {
            localStorage.setItem("auth_token", old_token);
        }
        localStorage.removeItem("auth_token_crocs");
        return localStorage.getItem("auth_token");
    }

    getUser() {
        return JSON.parse(<string>localStorage.getItem("auth_user_crocs"));
    }

    setToken(token: any) {

        if (!token || token == "undefined" || token == undefined) {
            localStorage.removeItem("auth_token");
        } else {
            localStorage.setItem("auth_token", token);
        }
    }

    setUser(user: any) {
        localStorage.setItem("auth_user_crocs", JSON.stringify(user));
        this.reactivityService.setDataToStore("loggedInUser", user);
        this.account.googleAnalaticsUserData = {
            loginState: "logged-in",
            userId: user.profile ? user.profile.id : user.id,
            firstName: user.profile ? user.profile.name : user.name,
            lastName: user.profile ? user.profile.last_name : user.last_name,
            email: user.profile ? user.profile.email : user.email,
            phoneNumber: user.profile ? user.profile.phone : user.phone,
            country: "eg",
            city: user.profile
                ? user.profile.primary_address
                : user.primary_address,
        };
    }
    editEmail(data: any) {
        return this.http
            .post<any>(
                `${environment.api}/api/customer/profile/edit/email`,
                data
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    removeToken() {
        localStorage.removeItem("auth_token");
        this.account.googleAnalaticsUserData = {
            loginState: "logged-out",
            userId: "",
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            country: "",
            city: "",
        };
    }

    removeUser() {
        this.embroService.productCartSub.next([]);
        this.embroService.compareListSub.next([]);
        this.embroService.favouritesListSub.next([]);
        this.embroService.notificationsListSub.next({});
        this.reactivityService.setDataToStore("loggedOutUser", true);
        localStorage.removeItem("auth_user_crocs");
    }

    isAuthenticated() {
        if (this.getUser() && !this.getUser()?.is_guest) {
            return true;
        } else {
            return false;
        }
    }

    logOut() {
        this.removeUser();
        this.removeToken();
        this.userEmit.emit({ is_guest: true });
        window.fcWidget?.user.clear();
        if (this.environmentVariables?.LOYALTY_PROVIDER == "gameBall") {
            logoutGameBall();
        }
    }

    setAreaDataEmit(data: any) {
        this.userAreaChanged.emit(data);
    }
    getAreaDataEmit() {
        return this.userAreaChanged;
    }
    setBranchDataEmit(data: any) {
        this.userAreaChanged.emit(data);
    }
    getBranchDataEmit() {
        return this.userAreaChanged;
    }

    setUserDataEmit(data: any) {
        this.userEmit.emit(data);
    }
    getUserDataEmit(): Observable<any> {
        return this.userEmit.asObservable();
    }
    isGuest() {
        return this.getUser()?.is_guest;
    }
}
